import { useState } from 'react';

const carouselItems = [
  {
    id: 1,
    title: '暑期档大片合集',
    desc: '炎炎夏日，宅家看片才是正经事。动作、喜剧、科幻、动画——今夏最热影片一次打包。',
    tag: '专题',
    imageSeq: 'carousel-01',
  },
  {
    id: 2,
    title: '导演王家卫作品回顾',
    desc: '重温光影诗人王家卫的经典作品，《花样年华》《重庆森林》《一代宗师》等全部上线。',
    tag: '回顾',
    imageSeq: 'carousel-02',
  },
  {
    id: 3,
    title: '2026上半年高分电影榜',
    desc: '盘点2026年上半年口碑最好的电影作品，部部精品，不容错过的观影指南。',
    tag: '榜单',
    imageSeq: 'carousel-03',
  },
  {
    id: 4,
    title: '诺兰电影全系列',
    desc: '从《记忆碎片》到《奥本海默》，克里斯托弗·诺兰的烧脑电影宇宙一次看个够。',
    tag: '合集',
    imageSeq: 'carousel-04',
  },
  {
    id: 5,
    title: '纪录片精选频道',
    desc: '自然、历史、科技、人文——这里有你从未见过的真实世界，每一部都值得静心观看。',
    tag: '精选',
    imageSeq: 'carousel-05',
  },
  {
    id: 6,
    title: '日韩影视热播榜',
    desc: '最新日剧韩剧电影资源大合集，追剧党的快乐源泉，每周持续更新热门内容。',
    tag: '热播',
    imageSeq: 'carousel-06',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">精选专题合集，发现更多你感兴趣的电影内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <CarouselCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CarouselCard({ item }: { item: typeof carouselItems[0] }) {
  const [imgError, setImgError] = useState(false);

  const imageUrls: Record<string, string> = {
    'carousel-01': 'https://readdy.ai/api/search-image?query=Summer%20vibe%20movie%20collage%20with%20popcorn%20and%20film%20strips%20on%20bright%20tropical%20background%20warm%20sunset%20colors%20cinematic%20summer%20blockbuster%20aesthetic%20vibrant%20energetic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    'carousel-02': 'https://readdy.ai/api/search-image?query=Hong%20Kong%20neon%20lit%20street%20at%20night%20with%20rain%20puddles%20reflecting%20colorful%20signs%20nostalgic%20cinematography%20warm%20amber%20and%20teal%20tones%20film%20grain%20texture%20Wong%20Kar%20Wai%20style%20aesthetic&width=800&height=500&seq=carousel-02&orientation=landscape',
    'carousel-03': 'https://readdy.ai/api/search-image?query=Golden%20film%20award%20trophies%20on%20dark%20velvet%20background%20with%20soft%20spotlight%20cinematic%20lighting%20elegant%20premium%20quality%20celebration%20atmosphere%20warm%20golden%20and%20deep%20black%20contrast&width=800&height=500&seq=carousel-03&orientation=landscape',
    'carousel-04': 'https://readdy.ai/api/search-image?query=Surreal%20mind%20bending%20geometric%20patterns%20with%20clock%20motifs%20and%20dreamlike%20landscape%20Nolan%20film%20inspired%20visual%20concept%20dark%20and%20mysterious%20atmosphere%20complex%20layered%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
    'carousel-05': 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20earth%20natural%20wonder%20with%20dramatic%20lighting%20documentary%20cinematography%20style%20vivid%20colors%20grand%20scale%20awe%20inspiring%20nature%20photography%20pristine%20landscape&width=800&height=500&seq=carousel-05&orientation=landscape',
    'carousel-06': 'https://readdy.ai/api/search-image?query=Modern%20Tokyo%20cityscape%20at%20dusk%20with%20warm%20city%20lights%20and%20cherry%20blossom%20branches%20in%20foreground%20cinematic%20Japanese%20drama%20aesthetic%20romantic%20atmosphere%20soft%20purple%20and%20orange%20sky&width=800&height=500&seq=carousel-06&orientation=landscape',
  };

  return (
    <a href="#cards" className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
      <div className="relative aspect-[16/10] overflow-hidden">
        {!imgError ? (
          <img
            src={imageUrls[item.imageSeq]}
            alt={item.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-image-line text-3xl text-foreground-400"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-background-950/10 to-transparent"></div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-950 text-xs font-bold whitespace-nowrap">{item.tag}</span>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
      </div>
    </a>
  );
}